import Store from '@material-ui/icons/Store';

import List from './List3';

export default {
  list: List,
  icon: Store,
};
